export const wcoxmlwebActions = {
  EXPORT_WCOXML_CONFIG: 'EXPORT_WCOXML_CONFIG',
  EXPORT_WCOXML_CONFIG_SUCCESS: 'EXPORT_WCOXML_CONFIG_SUCCESS',
  EXPORT_WCOXML_CONFIG_FAIL: 'EXPORT_WCOXML_CONFIG_FAIL',

  GET_WCOXML_WEB_DETAILS: 'GET_WCOXML_WEB_DETAILS',
  GET_WCOXML_WEB_DETAILS_SUCCESS: 'GET_WCOXML_WEB_DETAILS_SUCCESS',
  GET_WCOXML_WEB_DETAILS_FAIL: 'GET_WCOXML_WEB_DETAILS_FAIL',

  exportWcoXmlConfig: companyData => ({
    type: wcoxmlwebActions.EXPORT_WCOXML_CONFIG,
    payload: companyData,
  }),

  exportWcoXmlConfigSuccess: data => ({
    type: wcoxmlwebActions.EXPORT_WCOXML_CONFIG_SUCCESS,
    payload: { data },
  }),

  exportWcoXmlConfigFail: error => ({
    type: wcoxmlwebActions.EXPORT_WCOXML_CONFIG_FAIL,
    payload: { error },
  }),

  getWcoXmlWebDetails: companyId => ({
    type: wcoxmlwebActions.GET_WCOXML_WEB_DETAILS,
    payload: { companyId: companyId },
  }),

  getWcoXmlWebDetailsSuccess: data => ({
    type: wcoxmlwebActions.GET_WCOXML_WEB_DETAILS_SUCCESS,
    payload: { data },
  }),

  getWcoXmlWebDetailsFail: error => ({
    type: wcoxmlwebActions.GET_WCOXML_WEB_DETAILS_FAIL,
    payload: { error },
  }),
};

// fetch company wcoxml web details
// export wco_xml_web_config
